
import Block from 'Mixins/Block';

export default Block('component-search', {
	onLoad (qComponent) {

		if (qComponent.length) {

			qComponent.child('.component-search__close').addEvent('click', () => {
				qComponent.removeClass('component-search--active');
			});

			qComponent.child('.component-search__label').addEvent('click', () => {
				qComponent.addClass('component-search--active');
			});

			qComponent.child('.component-search__form').addEvent('submit', event => {

				const value = event.target.querySelector('.component-search__input').value.trim();
				if (!value.length) {

					event.preventDefault();

				}

			});

			qComponent.child('.component-search__label').addEvent('keydown', event => {

				switch (event.which) {
				case 13: // Enter
					event.preventDefault();

					qComponent.addClass('component-search--active');

					if (qComponent.child('.component-search__input')[0]) {

						qComponent.child('.component-search__input')[0].focus();

					}

					break;
				}
			});

		}

	}
});
